import { useEffect, useState } from 'react';

// Aligned with the rest of the codebase: SectionFooter and Topbar.js both
// treat 1024 as the mobile/desktop breakpoint. Keep this constant in sync
// if the brand ever bumps the breakpoint.
const MOBILE_MAX_WIDTH = 1023;

const getIsMobile = () => {
  if (typeof window === 'undefined') return true;
  return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
};

/**
 * Tracks viewport size with a single matchMedia listener.
 *
 * SSR safe: defaults to mobile on the server (matches the conservative
 * choice in SectionFooter), then snaps to the real value after mount.
 *
 * Returns `{ isMobile }`. Add more derived values here as later phases
 * need them — keep this hook the single source of truth so we don't
 * grow a fleet of one-off resize listeners.
 */
const useViewport = () => {
  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mql = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
    const onChange = e => setIsMobile(e.matches);

    // Snap to current value on mount in case it changed between SSR and hydration.
    setIsMobile(mql.matches);

    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return { isMobile };
};

export default useViewport;
